import { CheckMarkIcon } from '@braskai/icons';
import { Chip, Typography } from '@braskai/ui-kit';

import { Box, Stack } from '@mui/material';

import { useInterfaceLanguage } from '@/shared/i18n';
import { Plan } from '@/shared/types/Billing';

import { PRICING_CARD_FEATURES } from '../../constants/pricingCardFeatures';

type TPricingCardFeaturesProps = {
  isEnterprise: boolean;
  pricingCardActivePlan: Plan;
};

export const PricingCardFeatures = ({ isEnterprise, pricingCardActivePlan }: TPricingCardFeaturesProps) => {
  const { t } = useInterfaceLanguage();
  const textColor = isEnterprise ? 'common.white' : 'grey.900';
  const iconColor = isEnterprise ? 'common.white' : 'primary.600';

  const { features } = PRICING_CARD_FEATURES[pricingCardActivePlan.category];

  return (
    <Stack gap={12}>
      {features.map(({ badgeKey, labelKey }) => (
        <Stack key={labelKey} alignItems="flex-start" direction="row" gap={8}>
          <Box sx={{ color: iconColor, display: 'flex', flexShrink: 0 }}>
            <CheckMarkIcon height={20} width={20} />
          </Box>
          <Typography color={textColor} variant="body-2">
            {t(labelKey)}
            {badgeKey && (
              <Box component="span" sx={{ display: 'inline-flex', ml: 6, verticalAlign: 'middle' }}>
                <Chip label={t(badgeKey)} color="primary" data-testid={`pricing-card-badge-${labelKey}`} size="sm" />
              </Box>
            )}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
